import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import BackendUserForm from './BackendUserForm';
import FormToolbar from '../shared/FormToolbar';

const BackendUserEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <BackendUserForm {...props} />
    </SimpleForm>
  </Edit>
);

export default BackendUserEdit;
